import * as yup from 'yup'
import { translate as t } from '../../i18n'

export const athleteSchema = yup.object({
  name: yup
    .string()
    .trim()
    .required(() => t('general.validator.empty')),
  surname: yup
    .string()
    .required(() => t('general.validator.empty')),
  birthday: yup
    .date()
    .required(() => t('general.validator.empty')),
  genre: yup
    .string()
    .required(() => t('general.validator.empty')),
  email: yup
    .string()
    .lowercase()
    .required(() => t('general.validator.empty'))
    .email(() => t('general.validator.invalidEmail')),
  whatsapp: yup
    .string()
    .required(() => t('general.validator.empty'))
})
